import script from "./project-report-direct.vue?vue&type=script&lang=js&setup=true"
export * from "./project-report-direct.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__